// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import dayjs from "dayjs"
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import DocDListEditDialog from './DocDListEditDialog';

import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';

export default function DocDListTab(props) {
  const { sysID, docDetail, disableEdit, afterUpdate } = props;

  const distList = docDetail?.DList || [];

  // useEffect(() => {
  //   console.log("useEffect DocDListTab(did mounted)")

  // }, [])

  const gridData = distList.map(item => {
    return {
      ...item,
      Action: DmsCommon.ActionEnumToStr(item.ActionReq),
      Status: item.ReadDate ? `Read version ${item.ReadVer} on ${dayjs(item.ReadDate).format(DmsCommon.SHORT_DATETIME_FORMAT)} ` : "",
      PrevStatus: item.PrevDate ? `Read version ${item.PrevDate} on ${dayjs(item.PrevDate).format(DmsCommon.SHORT_DATETIME_FORMAT)} ` : "",
    }
  })

  // console.log("gridData", gridData);

  const [openEditDialog, setOpenEditDialog] = useState(false);



  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };


  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorUserName = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.ToUserName, nodeB.data.ToUserName)
  }

  const comparatorDept = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.DeptName, nodeB.data.DeptName)
  }

  const columnDefs = [
    { field: 'ToUserName', headerName: "Username", cellStyle: cellStyle, width: 150, sort: "asc", comparator: comparatorUserName },
    { field: 'DeptName', headerName: "Dept.", cellStyle: cellStyle, width: 100, comparator: comparatorDept },
    { field: 'Action', headerName: "Action", cellStyle: cellStyle, width: 120 },
    { field: 'Status', headerName: "Status", cellStyle: cellStyle, minWidth: 100, flex: "1" },
    { field: 'PrevStatus', headerName: "Previous Status", cellStyle: cellStyle, minWidth: 100, flex: "1" },
  ];
  // <AgGridColumn field="ToUserName" headerName="Username" cellStyle={cellStyle} width={150} sort="asc" ></AgGridColumn>
  // <AgGridColumn field="DeptName" headerName="Dept." cellStyle={cellStyle} width={100} ></AgGridColumn>
  // <AgGridColumn field="Action" headerName="Action" cellStyle={cellStyle} width={120} ></AgGridColumn>
  // <AgGridColumn field="Status" headerName="Status" cellStyle={cellStyle} flex="1" minWidth={100}></AgGridColumn>
  // <AgGridColumn field="PrevStatus" headerName="Previous Status" cellStyle={cellStyle} flex="1" minWidth={100}></AgGridColumn>

  const handleAfterUpdate = () => {
    setOpenEditDialog(false);

    afterUpdate && afterUpdate();
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: "70vh" }} >
      <Box sx={{ py: 1, px: 1 }} >

        <Button disabled={disableEdit} startIcon={<EditIcon />} onClick={() => setOpenEditDialog(true)}>
          Edit
        </Button>
        <DocDListEditDialog

          open={openEditDialog}
          onClose={() => setOpenEditDialog(false)}
          sysID={sysID}
          docDetail={docDetail}
          afterUpdate={handleAfterUpdate}
        />
      </Box>

      <div className="ag-theme-material" style={{ width: '100%', height: '100%', bgcolor: 'yellow' }}>
        <AgGridReact

          rowData={gridData}

          defaultColDef={{
            width: 100,
            resizable: true,
            sortable: true,
            suppressMovable: true,
          }}
          columnDefs={columnDefs}
          headerHeight={40}

          suppressNoRowsOverlay
        >

        </AgGridReact>

      </div>


    </Box>


  );
}

DocDListTab.propTypes = {
  sysID: PropTypes.string,
  docDetail: PropTypes.object,
  disableEdit: PropTypes.bool,
  afterUpdate: PropTypes.func,
};
